import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ProfileContentCard } from '../components/ProfileContentCard';

export const ProfilePageLayout: FC = () => (
  <ProfileContentCard>
    <Outlet />
  </ProfileContentCard>
);
